
import moment from 'moment'
import AddressInfo from './AddressInfo.vue'
import PhoneInfo from './PhoneInfo.vue'

export default {
  name: 'StoreDetails',
  components: {
    PhoneInfo,
    AddressInfo,
  },
  props: {
    location: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    operationHours() {
      const hours = this.location.hours;
      const dayRanges = [];
      let currentRange = null;

      // Define the days of the week in the desired order
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      for (let i = 0; i < daysOfWeek.length; i++) {
        const dayOfWeek = daysOfWeek[i];

        const hourEntry = hours?.find(hour => moment(hour.date, 'YYYYMMDD').format('dddd') === dayOfWeek);

        if (hourEntry && hourEntry.open && hourEntry.close) {
          const formattedOpen = this.formatTime(hourEntry.open);
          const formattedClose = this.formatTime(hourEntry.close);

          if (!currentRange || currentRange.close !== formattedClose || currentRange.open !== formattedOpen) {
            if (currentRange) {
              currentRange.days = currentRange.days.join(' - ');
              dayRanges.push(currentRange);
            }

            currentRange = {
              days: [dayOfWeek],
              hours: `${formattedOpen} - ${formattedClose}`,
              open: formattedOpen,
              close: formattedClose,
            };
          } else {
            currentRange.days.push(dayOfWeek);
          }
        }
      }

      if (currentRange) {
        currentRange.days = currentRange.days.join(' - ');
        dayRanges.push(currentRange);
      }

      const formatedDaysRange = dayRanges.map(item => {
        const daysArr = item.days.split(' - ');
        if (daysArr.length > 2) {
          item.days = `${daysArr[0]} - ${daysArr[daysArr.length - 1]}`
        }
        return item;
      });

      return formatedDaysRange;

    },
    attributes() {
      // console.log(this.location)
      if (this.location && this.location.attributes && this.location.attributes.length > 0) {
        return this.location.attributes.reduce((attributes, att) => {
          if (att && att.value && typeof att.value === 'string' && att.value.toLowerCase() === 'yes') {
            attributes.push(att.id.replace(/_/g, ' '))
          }
          if (att.id === 'wi_fi' && att.value !== 'unsure') {
            attributes.push(att.value.replace(/_/g, ' '))
          }
          if (att && att.value && Array.isArray(att.value) && att.value.length > 0) {
            const list = att.value.map(value => value.replace(/_/g, ' '))
            attributes.push(`${att.id.replace(/_/g, ' ')}: ${list.join(' • ')}`)
          }
          return attributes
        }, [])
      }
      return []
    },

    
  },
  methods: {
    formatTime(time) {
      return moment(time, 'HH:mm').format('h:mm A');
    },
  },
}
